import React, { FC, ReactElement } from 'react'
import { selectAiSlotById } from '@store/slices/aiSlot.slice'
import { EntityId } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '@store/store'
import {
  NarrationModel,
  selectNarrationsByIds,
} from '@store/slices/narration.slice'

const SlotStatusComponent: FC<{ aiSlotId: EntityId }> = ({
  aiSlotId,
}): ReactElement => {
  const aiSlot = useSelector((state: RootState) =>
    selectAiSlotById(state, aiSlotId)
  )
  const slotNarrations: NarrationModel[] = useSelector((state: RootState) =>
    aiSlot ? selectNarrationsByIds(state, aiSlot.narrations) : []
  )

  const audio = aiSlot?.narrations
    ? slotNarrations.reduce((accumulator: number, item: NarrationModel) => {
        if (item.audioUrl && !item.uploaded) {
          return accumulator + 1
        } else {
          return accumulator
        }
      }, 0)
    : 0
  const updated = aiSlot?.narrations
    ? slotNarrations.reduce((accumulator: number, item: NarrationModel) => {
        if (
          item.audioUrl &&
          item.audioCreated &&
          item.uploaded &&
          new Date(item.uploaded) < new Date(item.audioCreated)
        ) {
          return accumulator + 1
        } else {
          return accumulator
        }
      }, 0)
    : 0
  const published = aiSlot?.narrations
    ? slotNarrations.reduce((accumulator: number, item: NarrationModel) => {
        if (item.uploaded) {
          return accumulator + 1
        } else {
          return accumulator
        }
      }, 0)
    : 0
  const total = aiSlot && slotNarrations ? slotNarrations.length : 0
  return (
    <div className="d-flex gap-2">
      <span>
        Regiony publikováno <strong>{published}</strong>/
        <strong>{total}</strong>
      </span>
      <span>aktualizováno: {updated}</span>
      <span>audio: {audio}</span>
    </div>
  )
}

export default SlotStatusComponent
